import { createToast } from "@/modules/toast-message"
import { createAsyncApi } from "../../partials/async";

export default function createDeleteProgressionAPi(details) {
    /**
     * Delete progression for an existing key
     */
    const deleteProgression = createAsyncApi(
        'bt_memberships_clear_progress',
        'POST'
    )

    deleteProgression.api.callbacks.add(
        'onError',
        (data) => {
            if(data.code !== 404){
                createToast("Your progress failed to be cleared", "error")
            }
        }
    )

    deleteProgression.api.callbacks.add(
        'onSuccess',
        (data) => {
            createToast("Your progress has been cleared", "info")

            window.history.replaceState(null, null, window.location.pathname);

            details.value.key   = null
            details.value.email = ''
        }
    )

    return deleteProgression
}